<template>
  <nav
    class="navbar"
    :class="{ 'navbar--overlay': useTransparentNav }"
  >
    <div class="container nav-inner">
      <router-link to="/" custom v-slot="{ href, navigate }">
        <a
          :href="href"
          class="nav-brand"
          :class="{ 'nav-link-active': isBrandActive }"
          @click="(e) => { navigate(e); closeMenu(); }"
        >
          <img src="@/assets/logo.png" alt="" class="nav-brand__logo" width="72" height="72" decoding="async">
        </a>
      </router-link>

      <ul class="nav-menu" :class="{ open: menuOpen }">
        <li><router-link to="/" custom v-slot="{ href, navigate }"><a :href="href" :class="{ 'nav-link-active': isHomeItemActive }" @click="(e) => { navigate(e); closeMenu(); }">首页</a></router-link></li>
        <li><router-link to="/solutions" custom v-slot="{ href, navigate }"><a :href="href" :class="{ 'nav-link-active': isSolutionsActive }" @click="(e) => { navigate(e); closeMenu(); }">解决方案</a></router-link></li>
        <li><router-link to="/products" custom v-slot="{ href, navigate }"><a :href="href" :class="{ 'nav-link-active': isProductsActive }" @click="(e) => { navigate(e); closeMenu(); }">产品中心</a></router-link></li>
        <li><router-link to="/cases" custom v-slot="{ href, navigate }"><a :href="href" :class="{ 'nav-link-active': isCasesActive }" @click="(e) => { navigate(e); closeMenu(); }">案例展示</a></router-link></li>
        <li><router-link to="/news" custom v-slot="{ href, navigate }"><a :href="href" :class="{ 'nav-link-active': isNewsActive }" @click="(e) => { navigate(e); closeMenu(); }">最新动态</a></router-link></li>
        <li><router-link :to="{ path: '/', hash: '#about' }" custom v-slot="{ href, navigate }"><a :href="href" :class="{ 'nav-link-active': isHashActive('#about') }" @click="(e) => { navigate(e); closeMenu(); }">关于我们</a></router-link></li>
        <li><router-link :to="{ path: '/', hash: '#contact' }" custom v-slot="{ href, navigate }"><a :href="href" :class="{ 'nav-link-active': isHashActive('#contact') }" @click="(e) => { navigate(e); closeMenu(); }">联系我们</a></router-link></li>
      </ul>

      <button type="button" class="nav-toggle" :aria-expanded="menuOpen" aria-label="展开菜单" @click="menuOpen = !menuOpen">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavbarComponent',
  data() {
    return { menuOpen: false, scrollY: 0 }
  },
  computed: {
    /** 列表顶大图页：顶栏叠在横幅上，滚过横幅后恢复实底 */
    isInnerListHeroRoute() {
      const n = this.$route.name
      return n === 'news' || n === 'products' || n === 'solutions' || n === 'cases'
    },
    /**
     * 首页：叠在首屏轮播上透明；列表页（新闻/产品/方案/案例）叠在顶栏大图上透明，滚过后实底。
     */
    useTransparentNav() {
      if (typeof window === 'undefined') return true
      if (this.scrollY <= 8) return true
      if (this.isInnerListHeroRoute) {
        return this.scrollY < 300
      }
      if (this.$route.name !== 'home') return false
      const heroRevealPx = window.innerHeight * 0.88
      return this.scrollY < heroRevealPx
    },
    isSolutionsActive() {
      return this.$route.name === 'solutions' || this.$route.name === 'solution-detail'
    },
    isProductsActive() {
      return this.$route.name === 'products' || this.$route.name === 'product-detail'
    },
    isCasesActive() {
      return this.$route.name === 'cases' || this.$route.name === 'case-detail'
    },
    isNewsActive() {
      return this.$route.name === 'news' || this.$route.name === 'news-detail'
    },
    isBrandActive() {
      return this.$route.name === 'home'
    },
    isHomeItemActive() {
      return this.$route.name === 'home' && !this.$route.hash
    }
  },
  methods: {
    closeMenu() {
      this.menuOpen = false
    },
    isHashActive(expected) {
      return this.$route.name === 'home' && this.$route.hash === expected
    },
    onScroll() {
      this.scrollY = window.scrollY || 0
    }
  },
  watch: {
    $route() {
      this.$nextTick(() => this.onScroll())
    }
  },
  mounted() {
    this.onScroll()
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  /* 图二风格：深灰半透明，而不是纯色实底 */
  background: rgba(76, 76, 76, 0.50);
  backdrop-filter: saturate(120%) blur(4px);
  -webkit-backdrop-filter: saturate(120%) blur(4px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.14);
}

/* 首页：顶栏透明，轮播背景延伸到导航下方 */
.navbar.navbar--overlay {
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border-bottom: none;
  box-shadow: none;
}

.navbar.navbar--overlay .nav-inner {
  background: transparent;
}

.navbar.navbar--overlay .nav-brand,
.navbar.navbar--overlay .nav-menu a {
  color: #fff;
  text-shadow: 0 1px 10px rgba(0, 0, 0, 0.55);
}

.navbar.navbar--overlay .nav-menu a:hover {
  color: #bae6fd;
}

.navbar.navbar--overlay .nav-menu a.nav-link-active,
.navbar.navbar--overlay .nav-brand.nav-link-active {
  color: #fff;
  font-weight: 600;
}

.navbar.navbar--overlay .nav-brand__logo {
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.45));
}

.navbar.navbar--overlay .nav-toggle span {
  background: #fff;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.35);
}

.nav-inner {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 76px;
}

.nav-brand {
  display: inline-flex;
  align-items: center;
  z-index: 2;
  color: #000;
}

.nav-brand__logo {
  display: block;
  width: auto;
  height: 72px;
  max-width: 280px;
  object-fit: contain;
  flex-shrink: 0;
}

.nav-menu {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0 0 0 12px;
  padding: 0;
  height: 76px;
  display: flex;
  list-style: none;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  gap: 0 28px;
  z-index: 1;
}

/* 桌面：Logo 直接贴左侧显示，菜单保持居中 */
@media (min-width: 901px) {
  .navbar:not(.navbar--overlay) .nav-menu a {
    color: #e5e7eb;
  }

  .navbar:not(.navbar--overlay) .nav-menu a:hover,
  .navbar:not(.navbar--overlay) .nav-menu a.nav-link-active,
  .navbar:not(.navbar--overlay) .nav-brand.nav-link-active {
    color: #fff;
  }

  .nav-inner {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .nav-brand {
    position: fixed;
    /* 左侧留白略大于内容区，避免贴边 */
    left: max(84px, env(safe-area-inset-left, 0px));
    top: max(2px, env(safe-area-inset-top, 0px));
    transform: none;
    margin: 0;
    z-index: 1100;
  }

  .nav-menu {
    flex: 0 1 auto;
    margin: 0;
    justify-content: center;
  }

  .nav-toggle {
    position: absolute;
    right: 20px;
  }
}

.nav-menu li {
  margin: 0;
  flex-shrink: 0;
}

.nav-menu a {
  color: #334155;
  font-weight: 500;
  font-size: 18px;
  white-space: nowrap;
  padding: 6px 4px;
  transition: color 0.2s;
  border-radius: 4px;
}

.nav-menu a:hover { color: #2563eb; }

.nav-menu a.nav-link-active,
.nav-brand.nav-link-active { color: #000; }

.nav-menu a:focus { outline: none; }

.nav-menu a:focus-visible {
  outline: 2px solid rgba(37, 99, 235, 0.35);
  outline-offset: 3px;
}

.nav-toggle {
  display: none;
  margin-left: auto;
  z-index: 2;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.nav-toggle span {
  display: block;
  height: 2px;
  width: 22px;
  background: #334155;
  border-radius: 1px;
}

@media (max-width: 900px) {
  .nav-inner {
    display: flex;
    justify-content: flex-start;
    column-gap: 0;
  }

  .nav-toggle { display: flex; }

  .nav-menu {
    grid-column: auto;
    justify-self: stretch;
    flex: 1 1 auto;
    margin: 0 0 0 12px;
    justify-content: flex-start;
  }

  .nav-brand__logo {
    height: 54px;
    max-width: 200px;
  }

  .nav-menu {
    position: absolute;
    left: 0;
    right: 0;
    top: 76px;
    flex: none;
    min-width: 0;
    margin: 0;
    transform: none;
    height: auto;
    justify-content: stretch;
    flex-wrap: nowrap;
    background: #ffffff;
    flex-direction: column;
    align-items: stretch;
    padding: 16px 20px 24px;
    gap: 0;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
    transition: max-height 0.35s ease, opacity 0.25s ease;
    border-bottom: 1px solid #dbe7f5;
  }

  .nav-menu.open {
    max-height: 480px;
    opacity: 1;
    pointer-events: auto;
    box-shadow: 0 10px 20px rgba(37, 99, 235, 0.08);
  }

  .nav-menu li {
    margin: 0;
    border-bottom: 1px solid #eef3fb;
  }

  .nav-menu a {
    display: block;
    padding: 14px 8px;
    font-size: 17px;
  }
}
</style>
